// extracted by mini-css-extract-plugin
module.exports = {"duration":"_51l-n"};